import React from 'react';

import { withAuthLayout } from '@/layouts/Auth';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { Banner } from '@bypasslane/clover--web-lib-sprout-banner';
import { Card, CardBody } from '@bypasslane/clover--web-lib-sprout-card';
import { FormGroup } from '@bypasslane/clover--web-lib-sprout-form-group';
import {
  CountryCodeList,
  PhoneField,
  PhoneTextField
} from '@bypasslane/clover--web-lib-sprout-phone-text-field';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import '@/features/mfa/components/MfaDevices/ZeroState.css';

const SkipButton = ({ hideButton = false, handleClick }) => {
  if (hideButton) return null;
  return (
    <Action variant="flat" onClick={handleClick}>
      Skip for now
    </Action>
  );
};

SkipButton.propTypes = {
  hideButton: PropTypes.bool,
  handleClick: PropTypes.func.isRequired
};

const ZeroState = ({
  handleSave,
  handleSkip,
  phone,
  error,
  handleNumberChange,
  handleFormatted = () => {},
  handleE164,
  handleValidation,
  country,
  handleCountryChange,
  countryCodeListOptions,
  loading,
  disableSkipButton = false
}) => {
  return (
    <>
      <Banner
        ariaAtomic="true"
        className="mb-4"
        ariaLive="polite"
        closeable
        title=""
        variant="info"
      >
        <span>We use your mobile number to make your login process more secure.</span>
      </Banner>

      <div className="grid place-items-center">
        <div className={classNames('w-full max-w-xl', 'sm:max-w-none mb-4', 'sm:mb-0')}>
          <Card>
            <CardBody>
              <div className="form-container">
                <FormGroup>
                  <PhoneTextField className="phone-text-field">
                    <CountryCodeList
                      listOptions={countryCodeListOptions}
                      onChange={handleCountryChange}
                      value={country}
                    />
                    <PhoneField
                      format="national"
                      phoneNumber={phone}
                      onChange={handleNumberChange}
                      handleFormattedNumber={handleFormatted}
                      handleE164Number={handleE164}
                      errorText={error}
                      onValidationChange={handleValidation}
                      countryCode={country.value}
                      label="Mobile number"
                    />
                  </PhoneTextField>
                </FormGroup>
              </div>

              <hr className="my-4" />
              <p className="text-sm text-gray-600">
                By providing your mobile phone number to Clover Sport and selecting Next, you
                consent to receive SMS text messages for Clover Sport security purposes only.
                Standard message and data rates may apply.
              </p>
            </CardBody>
          </Card>
        </div>
        <div className="grid place-items-center gap-4 text-center mt-4">
          <Action onClick={handleSave} className="px-8" loading={loading}>
            <span className="px-9">Next</span>
          </Action>
          <SkipButton handleClick={handleSkip} hideButton={disableSkipButton} />
        </div>
      </div>
    </>
  );
};

export default withAuthLayout(ZeroState, {
  enableProfiler: true,
  enableErrorBoundary: true
});
ZeroState.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleSkip: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  error: PropTypes.string,
  handleNumberChange: PropTypes.func.isRequired,
  handleFormatted: PropTypes.func,
  handleE164: PropTypes.func.isRequired,
  handleValidation: PropTypes.func.isRequired,
  country: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  handleCountryChange: PropTypes.func.isRequired,
  countryCodeListOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  disableSkipButton: PropTypes.bool
};
